'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$002dDrug$002dRequest from "./app.api.-Drug-Requests-Accepted-List-Item$-Drug-Request.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$ as $c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$ };
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$ as $h_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$ };
$h_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$.prototype.toString__T = (function() {
  return "DrugRequest";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$.prototype.fromProduct__s_Product__Lapp_api_DrugRequestsAcceptedListItem$DrugRequest = (function(x$0) {
  var drugReqId$1 = x$0.productElement__I__O(0);
  var practice$1 = x$0.productElement__I__O(1);
  var drugRequest$1 = x$0.productElement__I__O(2);
  var yourResponse$1 = x$0.productElement__I__O(3);
  var seen$1 = (!(!x$0.productElement__I__O(4)));
  var maybeEpsCode$1 = x$0.productElement__I__O(5);
  var gpNote$1 = x$0.productElement__I__O(6);
  return new $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$002dDrug$002dRequest.$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest(drugReqId$1, practice$1, drugRequest$1, yourResponse$1, seen$1, maybeEpsCode$1, gpNote$1);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_DrugRequestsAcceptedListItem$DrugRequest(p);
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$, "app.api.DrugRequestsAcceptedListItem$DrugRequest$", ({
  Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$ as $d_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$ };
var $n_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$;
function $m_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$() {
  if ((!$n_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$)) {
    $n_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$ = new $c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$();
  }
  return $n_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$;
}
export { $m_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$ as $m_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest$ };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$-Drug-Request$.js.map
